
import { t } from 'i18next';
import { ReactComponent as ArrowsOutSimple } from '../../icons/arrow.out.simple.svg';

interface ViewLargerButtonProps {
  onClick: (e: React.MouseEvent) => void;
}

export default function ViewLargerButton({ onClick }: ViewLargerButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-[4px] px-3 py-[6px] bg-main-light-2 dark:bg-main-dark-2 rounded-[8px]"
    >
      <span className="text-pure-white dark:text-pure-black text-[14px]">
        {t('OfflineEventDetail.showLarge')}
      </span>

      <ArrowsOutSimple className="w-[14px] h-[14px] fill-pure-white dark:fill-pure-black" />
      {/* <img
        src="/assets/icons/arrows-out-simple.svg"
        alt="View Larger"
        className="w-[14px] h-[14px]"
      /> */}
    </button>
  );
}
